var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"thumbnail",class:{ 'clickable' : _vm.hasSrc },attrs:{"img-src":_vm.src}},[_c('div',{staticClass:"card-img-overlay"},[(_vm.hasSrc)?_c('span',{staticClass:"empty icon"},[_c('i',{staticClass:"fas fa-play fa-3x"})]):_c('span',{staticClass:"empty"},[_c('i',{staticClass:"fas fa-file-video fa-3x"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3986cce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/video-preview.vue
// module id = null
// module chunks = 